<template>
    <va-create-layout>
        <RentalTransactionEventFee-form
            :title="title"
            :item="item"
        ></RentalTransactionEventFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
